import { PropositionButtonSchema } from '@/views/sports/components/PropositionButton/styles/PropositionButton.styles';

export const propositionButtonStyles: PropositionButtonSchema = {
  buttonBase: {
    variant: 'odds',
  },
  buttonBaseSpanProps: {
    overflow: 'hidden',
    pos: 'relative',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    alignSelf: 'center',
    textTransform: 'uppercase',
    fontWeight: 'extrabold',
    fontFamily: 'accent',
    fontSize: '2xs',
    top: 'px',
    zIndex: 9,
  },
  buttonBaseBox: {
    fontSize: 'xs',
    fontWeight: 'bold',
    fontFamily: 'accent',
  },
  textBase: {
    textAlign: 'center',
    color: 'blackAlpha.800',
  },
};
